export default "__VITE_ASSET__DkVWNxx5__"